import axios from 'axios';
import { getAccessToken } from './shared';
import { Auth } from 'aws-amplify';
import API_ENDPOINTS from '../apiEndpoints';

let axiosInstanceForLambda = axios.create();

// Add request interceptor to include authorization token
axiosInstanceForLambda.interceptors.request.use(
  async (config) => {
    const session = await Auth.currentSession();
    const accessToken = session.getAccessToken();
    const tokenExpiryTime = accessToken.getExpiration() * 1000;

    if (Date.now() > tokenExpiryTime) {
      // Refresh the session if the token has expired
      const refreshedSession = await Auth.refreshSession(session.getRefreshToken());
      config.headers.Authorization = `Bearer ${refreshedSession.getAccessToken().getJwtToken()}`;
    } else {
      config.headers.Authorization = `Bearer ${accessToken.getJwtToken()}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor for retry logic
axiosInstanceForLambda.interceptors.response.use(
  (response) => response, // Pass through successful responses
  async (error) => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      // Mark the request as retried
      originalRequest._retry = true;
      try {
        // Refresh the token
        const session = await Auth.currentSession();
        const access = session?.accessToken?.jwtToken;
        // Update the Authorization header
        axiosInstanceForLambda.defaults.headers.common.Authorization = `Bearer ${access}`;
        originalRequest.headers.Authorization = `Bearer ${access}`;

        // Retry the original request with the new token
        return axiosInstanceForLambda(originalRequest);
      } catch (refreshError) {
        // If refreshing the token fails, reject the promise
        return Promise.reject(refreshError);
      }
    }

    // If the error is not a 401 or retry fails, reject the promise
    return Promise.reject(error);
  }
);

export { axiosInstanceForLambda };
export const createPDF = async (path, CompanyID, type, InvoiceID) => {
  let response = await axiosInstanceForLambda.post(API_ENDPOINTS.REACT_APP_GENERATE_PDF_PDFKIT, {
    companyID: CompanyID,
    path: path,
    InvoiceIDS: [InvoiceID],
    type: type,
  });
  console.log(response);
  return response;
};
